/* 国家选项加载工具函数 */

import { CompanyInfoService } from '../../../_services';

/**
 * 从 CDN 加载国家选项数据（用于 ContactUs 等）
 * @param {number} langId - 语言ID（936简体, 950繁体, 1252英文）
 * @returns {Promise<Array>} 国家选项数组，格式：[{ value: string, text: string }]
 */
export async function loadCountryOptions(langId) {
  try {
    const url = `https://cdn.adsalecdn.com/CPS24/Files/Data/GetShowPreregOptionData_Mychinaplas_Cloud_${langId || 1252}.json`;
    const response = await fetch(url, {
      method: 'GET'
    });
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    const data = await response.json();
    
    if (data && data.CountryList && Array.isArray(data.CountryList)) {
      return data.CountryList.map(country => ({
        value: country.Name,
        text: country.Name
      }));
    }
    
    return [];
  } catch (error) {
    return [];
  }
}

/**
 * 加载手机区号选项数据（统一使用 GetCellCountryData，参考 MyUsers.vue）
 * @returns {Promise<Array>} 区号选项数组，格式：[{ value: string, text: string, area: string, countryId: number }]
 */
export async function loadCellCountryOptions() {
  try {
    const list = await CompanyInfoService.GetCellCountryData();
    const mapped = list.map(item => {
      const countryId = item.Code || null;
      const areaCode = item.Option || '';
      const value = areaCode ? `+${areaCode}` : '+86';
      const text = item.Name || value;
      
      return {
        value: value,
        text: text,
        area: areaCode,
        countryId: countryId
      };
    });
    
    // 去重，按 value 首次出现保留
    const seen = new Set();
    return mapped.filter(opt => {
      if (seen.has(opt.value)) return false;
      seen.add(opt.value);
      return true;
    });
  } catch (error) {
    console.error('Load cell country options failed:', error);
    return [];
  }
}

/**
 * 获取当前语言ID
 * @returns {number} 语言ID（936简体, 950繁体, 1252英文）
 */
export function getCurrentLangId() {
  return parseInt(localStorage.getItem('currentLangId')) || 1252;
}

